import styled from 'styled-components';

import BootstrapModal from 'react-bootstrap/Modal';

export const StyledModal = styled(BootstrapModal)``;

export const StyledModalBody = styled(BootstrapModal.Body)``;
